import { render, staticRenderFns } from "./Memorando.vue?vue&type=template&id=4c802782&"
import script from "./Memorando.vue?vue&type=script&lang=js&"
export * from "./Memorando.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports